import { create } from 'zustand';

interface IStorageState {
  resetDataWithLoaders: boolean;
  setResetDataWithLoaders: (resetDataWithLoaders: boolean) => void;
}

const useStorageState = create<IStorageState>(set => ({
  resetDataWithLoaders: false,
  setResetDataWithLoaders: resetDataWithLoaders => set({ resetDataWithLoaders })
}));

export default useStorageState;
